/* eslint-disable */
export default {
  _BPreplay_Regular: 'BPreplay-Regular',
  _Comic_Sans_MS: 'Comic Sans MS',
  _BPreplay_Bold: 'BPreplay-Bold',
}

// TODO remove this
/**
 * Font size adjustments:
 * 13 -> 16
 * 18 -> 22
 * 24 -> 30
 * 32 -> 38
 * 36 -> 44
 * 42 -> 58
 */